<div class="relative">
  <div class="ml-8 mr-3">
    @if (toast().title; as title) {
      <div class="font-bold">{{ title }}</div>
    }
    {{ toast().message }}
  </div>
  <button
    type="button"
    aria-label="Fermer la notification"
    (click)="close()"
    class="absolute right-0 top-0 -mr-3 -mt-3 h-auto cursor-pointer rounded-full border border-solid border-white bg-transparent p-0 shadow-none"
  >
    <img class="h-4" src="/assets/icons/close.svg" alt="" />
  </button>
</div>
